import React, { useEffect } from 'react';
import Header from './components/header';
import { Grid } from '@mui/material';
import Footer from './components/footer';
import portfolio1 from './assets/img/portfolio/1.png';
import portfolio2 from './assets/img/portfolio/2.png';
import portfolio3 from './assets/img/portfolio/3.png';
import portfolio4 from './assets/img/portfolio/4.png';
import portfolio5 from './assets/img/portfolio/5.png';
import portfolio6 from './assets/img/portfolio/6.png';
import portfolio7 from './assets/img/portfolio/7.png';
import portfolio8 from './assets/img/portfolio/8.png';
import SEOTags from './common/SEO';

const portfolioData = [
    {
        image: portfolio1,
        description: 'Figgers Communication is an American telecommunications company and cellular phone manufacturer based in Florida. It provides cellular, mobile broadband, home phone and international calling services.'
    },
    {
        image: portfolio2,
        description: 'Figgers Wireless is an American telecommunications company that offers wireless products and services. It is a division of Figgers Communication.',
        link: 'https://figgers.com/'
    },
    {
        image: portfolio3,
        description: 'Figgers Foundation is an American private foundation that bring awareness and provide solutions to a number of real life issues that so many face everyday globally.',
        link: 'https://figgersfoundation.org/'
    },
    {
        image: portfolio4,
        description: 'FiggHealth is an American Healthcare technology manufacture that aims at improving the living standard of chronic health for blood sugar remote monitoring systems by introducing them to all innovative technology.',
        link: 'https://figg.health/'
    },
    {
        image: portfolio5,
        description: 'FiggCash is an American financial technology and virtual bank.',

    },
    {
        image: portfolio6,
        description: 'Figgers Electronics is an American multinational consumer electronics manufacturing company.',

    },
    {
        image: portfolio7,
        description: 'Figgers Technologies is an American multinational technology and consulting company.'
    },
    {
        image: portfolio8,
        description: 'Figgers Real Estate is an American real estate holding company, with a diverse portfolio from residential, multi families and commercial shopping centers.'
    },
];

const Portfolio = () => {

    useEffect(() => {
        SEOTags(
            "Portfolio | Freddie Figgers",
            "commence your Monday with uplifting and powerful quotes that spark motivation, boost productivity, and set a positive tone for a successful week ahead.",
            "Portfolio, Freddie Figgers"
        );
    }, [])

    return (
        <>

            <Header />

            <div className="layout_container">
                <Grid container spacing={4} className="portfolio-container">
                    <Grid item xs={12} sm={4}>
                        <div className='portfolio-heading'>
                            <h2>Portfolio</h2>
                            <hr></hr>
                        </div>
                    </Grid>
                    {portfolioData.map((item, index) => (
                        <Grid item xs={12} sm={4} key={index}>
                            <a href={item.link} target="_blank" rel="noopener noreferrer">
                                <div className="portfolio-item" style={{ cursor: item.link ? 'pointer' : 'unset' }}>
                                    <div className="flip-box">
                                        <div className="flip-box-inner">
                                            <div className="flip-box-front">
                                                <img src={item.image} alt={`Portfolio ${index + 1}`} />
                                            </div>
                                            <div className="flip-box-back">
                                                <p>{item.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </Grid>
                    ))}
                </Grid>
            </div>

            <Footer />
        </>
    );
};

export default Portfolio;
